import { makeStyles } from '@rbx/ui';

const useArticleNavigationSectionStyles = makeStyles()(() => ({
  prevContainer: {
    marginRight: 'auto',
  },

  nextContainer: {
    marginLeft: 'auto',
  },
  buttonContainer: {
    paddingTop: 16,
  },
}));

export default useArticleNavigationSectionStyles;
